<template>
    <a-card type="inner" size="small" :bordered="false" style="margin-top: 20px;">
        <a-form-model ref="ruleForm" :model="form" :labelCol="labelCol" :wrapperCol="wrapperCol" :rules="rules">
            <a-divider dashed orientation="left">Informasi Pertanyaan</a-divider>
            <a-form-model-item label="Pertanyaan" prop="content">
                <a-textarea
                    v-model="form.content"
                    placeholder="Soal"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
            </a-form-model-item>

            <a-form-model-item label="Order" prop="order" :wrapper-col="{ span: 5 }">
                <a-input-number v-model="form.order" />
            </a-form-model-item>

            <a-form-model-item label="Randomize" prop="answer_in_random_order">
                <a-switch v-model="form.answer_in_random_order" />
            </a-form-model-item>

            <a-form-model-item label="Jawaban" prop="answer">
                <a-row v-for="(answer, index) in form.answers" :key="index" :gutter="16">
                    <a-col :span="18" >
                        <a-input v-model="form.answers[index].content" />
                    </a-col>
                    <a-col :span="6" style="text-align: center">
                        <a-checkbox v-model="form.answers[index].is_correct_answer" @change="(e) => onChange(e, index)" />
                    </a-col>
                </a-row>
            </a-form-model-item>

            <a-form-model-item label="Pembahasan" prop="discussion">
                <a-textarea placeholder="Pembahasan" :rows="4" v-model="form.discussion" />
            </a-form-model-item>

            <a-form-model-item :wrapperCol="{ span: this.wrapperCol.span, offset: this.labelCol.span }">
                <a-button :loading="loading" type="primary" @click="submit" icon="save">Save</a-button>
            </a-form-model-item>
        </a-form-model>
    </a-card>
</template>

<script>
export default {
    props: {
        exam: {
            type: Object,
            required: true
        },
        question: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            editing: false,
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            loading: false,
            form: null,
            prevIndex: null,
            rules: {
                content: [
                    { required: true, message: 'Silahkan masukkan pertanyaan', trigger: 'blur' },
                ],
            },
        }
    },
    created() {
        this.freshData()

        if (this.question !== null) {
            this.editing = true
            this.form = this.question

            for (let index = 0; index < this.form.answers.length; index++) {
                if(this.form.answers[index].is_correct_answer){
                    this.form.answers[index].is_correct_answer = true
                }else{
                    this.form.answers[index].is_correct_answer = false
                }
            }
        }
    },
    methods: {
        freshData() {
            this.form = {
                content: null,
                order: 0,
                answer_in_random_order: true,
                answers: [
                    {
                        content: null,
                        order: 0,
                        is_correct_answer: false
                    }, {
                        content: null,
                        order: 0,
                        is_correct_answer: false
                    }, {
                        content: null,
                        order: 0,
                        is_correct_answer: false
                    }, {
                        content: null,
                        order: 0,
                        is_correct_answer: false
                    }
                ]
            }
        },
        submit() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    var arrContent = this.form.answers.filter(function(ele){
                        return (ele.content == null || ele.content == "")
                    });

                    if(arrContent.length >= 1){
                        this.$notification.error({
                            message: "Gagal diproses",
                            description: "Isian jawaban harus diisi semua"
                        })

                        return false;
                    }

                    var arrAnswer = this.form.answers.filter(function(ele){
                        return (ele.is_correct_answer == 1)
                    });

                    if(arrAnswer.length == 0){
                        this.$notification.error({
                            message: "Gagal diproses",
                            description: "Pertanyaan harus memiliki minimal 1 jawaban."
                        })

                        return false;
                    }

                    this.loading = true
                    return this.editing ? this.update() : this.store()
                } else {
                    return false;
                }
            });
        },
        store() {
            this.$http.post(this.routeUri('api.material-exam.questions.store', { exam: this.exam.id }), this.form)
                .then(() => this.onSuccessCreating())
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => this.loading = false)
        },
        update() {
            this.$http.put(this.routeUri('api.material-exam.questions.update', { exam: this.exam.id, question: this.question.hash }), this.form)
                .then(() => this.onSuccessUpdating())
                .catch((error) => this.handleResponseError(error.response.data))
                .finally(() => this.loading = false)
        },
        onSuccessCreating() {
            this.$emit('saved', this.form)
            this.$emit('created', this.form)
            this.freshData()

            this.$notification.success({
                message: "Saved!",
                description: "Pertanyaan berhasil tersimpan."
            })
        },
        onSuccessUpdating() {
            this.$emit('saved', this.form)
            this.$emit('updated', this.form)
            this.freshData()
            this.$notification.success({
                message: "Updated!",
                description: "Pertanyaan berhasil diperbarui."
            })
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        onChange(e, index) {
            if(this.prevIndex != null && this.prevIndex != index){
                this.form.answers[this.prevIndex].is_correct_answer = false
            }

             this.prevIndex = index
        },
    }
}
</script>
